import styled from 'styled-components';
import tw from 'tailwind.macro';

export const ContactInfoItem = styled.div`
  ${tw`w-full sm:w-1/3`};
`;
